module.exports = __webpack_public_path__ + "img/patient-info-down.6b335108.svg";